import React, { Fragment } from 'react';

import { Column } from 'buyside/components/base/Card/Card';
import FlashMessage from 'buyside/components/presentation/FlashMessage/flashMessage';
import MessageForm, {
  TextArea,
  SubmitButton,
  MessageFormErrors,
  AttachmentArea
} from 'buyside/components/presentation/MessageForm/MessageForm';

import styles from './MessageThreadFormStyles';

class MessageThreadForm extends React.Component {
  constructor() {
    super();
    this.state = {
      error: null
    };
    this.handleError = this.handleError.bind(this);
  }

  handleError(error) {
    this.setState({ error: error['graphQLErrors'][0]['message'] });
  }

  render() {
    const { threadNum, createMessage, afterSubmit, analyticsTag } = this.props;

    return (
      <Fragment>
        {this.state.error && (
          <FlashMessage>
            {({ flashMessageStyles }) => (
              <div className={`${flashMessageStyles} ${styles.flashMessage}`}>
                {this.state.error}
              </div>
            )}
          </FlashMessage>
        )}

        <MessageForm
          thread={threadNum}
          createMessage={createMessage}
          afterSubmit={afterSubmit}
          handleError={this.handleError}
        >
          <Column>
            <MessageFormErrors />
            <TextArea placeholder="Reply to this Message..." />
            <AttachmentArea />
            <div className={styles.buttonContainer}>
              <SubmitButton text="Send" analyticsTag={analyticsTag} />
            </div>
          </Column>
        </MessageForm>
      </Fragment>
    );
  }
}

export default MessageThreadForm;
